import { applyMiddleware, createStore, Middleware } from 'redux'
import createSagaMiddleware, { Task } from 'redux-saga'
import { createWrapper } from 'next-redux-wrapper'
import type { Store as StoreType } from 'redux'

import rootReducer, { initialState } from './reducers'
import rootSaga from './sagas/index'

import type { State } from './reducers'
import type { Actions } from './actions'

export type Store = StoreType<State, Actions>
// See https://github.com/kirill-konshin/next-redux-wrapper#usage-with-redux-saga
export interface SagaStore extends StoreType {
  sagaTask?: Task
}

const bindMiddleware = (middlewares: Middleware[]) => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('@redux-devtools/extension')
    return composeWithDevTools(applyMiddleware(...middlewares))
  }
  return applyMiddleware(...middlewares)
}

function makeStore() {
  const sagaMiddleware = createSagaMiddleware()

  const store = createStore(rootReducer, initialState, bindMiddleware([sagaMiddleware])) as SagaStore

  store.sagaTask = sagaMiddleware.run(rootSaga)
  return store
}

export default makeStore
export const wrapper = createWrapper<Store>(makeStore, { debug: false })
